import React from "react";
import { FormattedNumber } from "react-intl";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { faFile, faFileExcel, faFileArchive } from "@fortawesome/free-regular-svg-icons";

import { Icon } from "@ui/Icon";
import { File as Model } from "../../models";

interface FileProps {
    file: Model;
}

interface FileSize {
    value: number;
    units: string;
}

const getFileSize = (bytes: number/*, si: boolean = true*/): FileSize => {
    const thresh = /*si ? */1000/* : 1024*/;
    if (Math.abs(bytes) < thresh) {
        return { value: bytes, units: "B" };
    }
    const units = /*si
        ? */["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        // : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return { value: bytes, units: units[u] };
};

export const FileSize = ({ bytes }: { bytes: number; }) => {
    const size = getFileSize(bytes);
    return (
        <span className="text-muted">
            <FormattedNumber value={size.value} maximumFractionDigits={1} />
            {" "}{size.units}
        </span>
    );
};

export const File = ({ file }: FileProps) => {
    let icon = faFile;
    if (file.formatExt != null && file.formatExt.startsWith("xls")) {
        icon = faFileExcel;
    }
    else if (file.formatExt === "zip") {
        icon = faFileArchive;
    }
    return (
        <Card className="file">
            <CardBody>
                <Row>
                    <Col xs="auto" className="file__icon">
                        <Icon icon={icon} size="4x" inverse={false} />
                    </Col>
                    <Col>
                        <CardTitle tag="h5">{file.origFilename}</CardTitle>
                        {file.meta != null && file.meta.size != null &&
                            <FileSize bytes={file.meta.size} />
                        }
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};
